export default __webpack_public_path__ + "static/media/placeholder_dummy2016-sprachunterricht01-mobile-de.c8ee1be9.png";